<template>  
    <div class="p-inputtext-sm">
        <div class="grid">
            <div class="col-6">
                <FormField :labelName="$t('loading')" fieldName="Order_Type" v-model="assignModel" fieldClass="col-8" labelClass="col-4">
                    <!--<CustomSelect class="p-inputtext-sm" v-model="assignModel.loading_destination_from_id" :url="this.$API_URL + 'list/location'" :minLength="0" :params="{ }" v-if="assignModel" :filter="true" :disabled="orderLinkSTO || blockLoading || disableInput" @change="resetTransporter"/> -->
                    <CustomSelect class="p-inputtext-sm" v-model="assignModel.loading_destination_from_id" :url="this.$API_URL + 'list/location'" :minLength="0" :params="{ }" v-if="assignModel" :filter="true" @change="resetTransporter"/>
                </FormField>

                <FormField :labelName="$t('stuffing_date')" fieldName="Stuffing_Date" v-model="assignModel" fieldClass="col-8" labelClass="col-4">
                    <DatePicker dateFormat="dd/mm/yy" class="p-inputtext-sm" v-model="assignModel.stuffing_date" selectionMode="range" v-if="assignModel" :minDate="stuffingDateFromRange" :maxDate="stuffingDateToRange" :disabled="disableInput"/>
                </FormField>

                <FormField :labelName="$t('trip_type')" fieldName="Trip_Type" v-model="assignModel" fieldClass="col-8" labelClass="col-4">
                    <!-- <CustomSelect class="p-inputtext-sm" v-model="assignModel.loading_destination_to_id" :url="this.$API_URL + 'list/location'" :minLength="0" :params="{ }" v-if="assignModel" :filter="true" :disabled="orderLinkSTO || blockDestination || disableInput || validateAutoAssign" @change="resetTransporter"/> -->
                    <CustomSelect class="p-inputtext-sm" v-model="assignModel.trip_type" :url="this.$API_URL + 'list/lookup'" :minLength="0" :params="{ group: this.$LOOKUP_GROUP.FREIGHT_TRIP_TYPE  }" v-if="assignModel" :filter="true" @change="resetTransporter"/>
                </FormField>

                <FormField :labelName="$t('route_no')" fieldName="Route_No" v-model="assignModel" fieldClass="col-8" labelClass="col-4">
                    <div class="p-inputgroup" >
                        <YNCheckbox v-model="assignModel.use_route" :binary="true" v-if="assignModel" class="mr-1" :disabled="disableRouteTenderNo"/>
                        <!-- <InputText name="Route_No" type="text" v-if="assignModel" v-model="assignModel.route_no" disabled/> -->
                        <InputText name="Route_No" type="text" v-if="assignModel" v-model="assignModel.route_name" disabled/>
                    </div>
                </FormField>
                
                <FormField :labelName="$t('tender_no')" fieldName="Tender_No" v-model="assignModel" fieldClass="col-8" labelClass="col-4" v-if="hideTenderNo">
                    <div class="p-inputgroup">
                        <YNCheckbox v-model="assignModel.use_tender" :binary="true" v-if="assignModel"  class="mr-1" :disabled="disableRouteTenderNo"/>
                        <InputText name="Route_No" type="text"  v-if="assignModel" v-model="assignModel.tender_no" disabled/>
                    </div>
                </FormField>

                
                <FormField :labelName="$t('sto_spo_per_shipment')" fieldName="STO_SPO_Per_Shipment" v-model="assignModel" fieldClass="col-8" labelClass="col-4" v-if="showSTOSPOPerShipment">
                    <div class="p-inputgroup">
                        <YNCheckbox v-model="assignModel.sto_spo_per_shipment" :binary="true" v-if="assignModel"  class="mr-1" />
                    </div>
                </FormField>

                <!-- <FormField :labelName="$t('charge_oa_company')" fieldName="Charge_OA_Company" v-model="assignModel" fieldClass="col-8" labelClass="col-4">
                    <CustomSelect class="p-inputtext-sm" v-model="assignModel.charge_oa_company" :url="this.$API_URL + 'list/company_code'" :minLength="0" :params="{ }" v-if="assignModel" :filter="true" :disabled="disableInput"/>
                </FormField> -->

                <!-- <div v-if="phase2">
                    <FormField :labelName="$t('ln_type')" fieldName="ln_type" v-model="assignModel" fieldClass="col-8" labelClass="col-4">
                        <InputText class="p-inputtext-sm" v-model="assignModel.ln_type" v-if="assignModel"  :disabled="disableLNType"/>
                    </FormField>

                    <FormField :labelName="$t('incoterm_rule')" fieldName="ln_inco_rule" v-model="assignModel" fieldClass="col-8" labelClass="col-4">
                        <CustomSelect class="p-inputtext-sm" v-model="assignModel.ln_inco_rule" :url="this.$API_URL + 'list/incoterm_rule'" :minLength="0" :params="{ ln_type: assignModel.ln_type }" v-if="assignModel" :filter="true" :disabled="!requireLNIncoRule"/>
                    </FormField>
                </div> -->
            </div>
            <div class="col-6">
                <FormField :labelName="$t('destination')" fieldName="Loading_Destination_To_Id" v-model="assignModel" fieldClass="col-8" labelClass="col-4">
                    <!-- <CustomSelect class="p-inputtext-sm" v-model="assignModel.loading_destination_to_id" :url="this.$API_URL + 'list/location'" :minLength="0" :params="{ }" v-if="assignModel" :filter="true" :disabled="orderLinkSTO || blockDestination || disableInput || validateAutoAssign" @change="resetTransporter"/> -->
                    <CustomSelect class="p-inputtext-sm" v-model="assignModel.loading_destination_to_id" :url="this.$API_URL + 'list/location'" :minLength="0" :params="{ }" v-if="assignModel" :filter="true" :disabled="orderLinkSTO || blockDestination || disableInput" @change="resetTransporter"/>
                </FormField>
                
                <FormField :labelName="$t('freight_date')" fieldName="Freight_Date" v-model="assignModel" fieldClass="col-8" labelClass="col-4" v-if="!isRelation">
                    <DatePicker :placeholder="$t('freight_date')" dateFormat="dd/mm/yyyy" inputMask="99/99/9999" momentFormat="DD/MM/YYYY" class="p-column-filter p-inputtext-sm" v-if="assignModel" v-model="assignModel.freight_date" :disabled="disableInput || validateAutoAssign" />
                </FormField>
                
                <FormField :labelName="$t('vessel')" fieldName="Vessel" v-model="assignModel" fieldClass="col-8" labelClass="col-4">
                    <InputText class="p-inputtext-sm" v-model="assignModel.vessel" v-if="assignModel"  :disabled="disableInput"/>
                </FormField>

                <div class="field grid">
                    <label for="Transporter_Notes" class="col-4 p-p-4">{{ isRelation ? $t('customer_vendor_notes') : $t('transporter_notes')}}</label>
                    <div class="col-8 md-8">
                        <Textarea class="p-inputtext-sm" v-model="assignModel.transporter_notes" :autoResize="true" rows="3" cols="30" v-if="assignModel" :disabled="disableInput"/>
                        <Skeleton v-if="!assignModel" />
                    </div>
                </div>
            </div>
        </div>
        
        <div v-if="isIndividual">
            <div class="field grid">
                <label for="Transporter_Code" class="col-2 p-p-2">{{ isRelation ? $t('customer_vendor') : $t('transporter')}}</label>
                <div class="col-4 md-4">
                    <div class="p-inputgroup" v-if="transporters.length > 0">
                        <InputText name="Transporter_Code" type="text" disabled v-model="transporters[0].transporter_name"/>
                        <Button icon="pi pi-ellipsis-h" class="p-button p-button-sm" @click="onShowTransporterModal(0)"  :disabled="orderLinkSTO || isRelation || disableInput"/>
                    </div>
                    <Skeleton v-if="!(transporters.length > 0)" />
                </div>

                <Message severity="error" :closable="false" v-if="transporters.length > 0 && transporters[0].exceed_message">{{transporters[0].exceed_message}}</Message>

                <label for="SAP_Truck_Type" class="col-2 p-p-2" v-if="sapOrders.length > 0 && sapTruckTypesDisplay">{{$t('truck_type')}}</label>
                <div class="col-4 md-4">
                    <div class="p-inputgroup" v-if="sapOrders.length > 0 && sapTruckTypesDisplay">
                        <InputText name="SAP_Truck_Type" type="text" disabled v-model="sapTruckTypesDisplay" />
                    </div>
                    <Skeleton v-if="!(sapOrders.length > 0)" />
                </div>
            </div>
            <div class="field grid">
                <label for="Truck_Type_Id" class="col-2">{{$t('truck_type')}}</label>
                <div class="col-4 md-4">
                    <CustomSelect class="p-inputtext-sm" v-model="transporters[0].truck_type_id" :url="this.$API_URL + 'list/truck_type'" :minLength="0" :params="{ }" v-if="transporters.length > 0" disabled />
                    <Skeleton v-if="!(transporters.length > 0)" />
                </div>

                <div v-if="allowMultipleWeighing">
                    <label for="Multiple_Weighing" class="col-2">{{$t('multiple_weighing')}}</label>
                    <div class="col-4 md-4">
                        <YNCheckbox v-model="transporters[0].multiple_weighing" v-if="transporters.length > 0" :binary="true" />
                        <Skeleton v-if="!(transporters.length > 0)" />
                    </div>

                </div>
            </div>
            <div class="field grid">
                <label for="Freight_Cost" class="col-2">{{$t('freight_cost')}}</label>
                <div class="col-4 md-4">
                    <InputNumber name="Freight_Cost" mode="decimal" :optionalDecimal="true" v-model="transporters[0].freight_cost" v-if="transporters.length > 0" @blur="onFreightCostChange($event, 0)" :disabled="orderLinkSTO || isRelation || disableInput || validateAutoAssign"/>
                    <Skeleton v-if="!(transporters.length > 0)" />
                </div>
                
                <label for="Freight_Cost" class="col-2">{{$t('freight_total_cost_user_not')}}</label>
                <div class="col-4 md-4">
                    <InputNumber name="Freight_Total_Cost_User_NoT" mode="decimal" :optionalDecimal="true" disabled v-model="transporters[0].freight_total_cost_user_not" v-if="transporters.length > 0"/>
                    <Skeleton v-if="!(transporters.length > 0)" />
                </div>
            </div>
            <div class="field grid"  v-if="!isRelation">
                <label for="Freight_Container" class="col-2">{{$t('user_num_trip')}}</label>
                <div class="col-4 md-4">
                    <div class="p-inputgroup">
                       <InputNumber name="Freight_Container" mode="decimal" :optionalDecimal="true" disabled v-model="transporters[0].freight_container" v-if="transporters.length > 0"/>
                        <span class="p-inputgroup-addon" v-if="transporters.length > 0" style="padding-left:2rem; padding-right:2rem;">{{transporters[0].freight_uom}}</span>
                    </div>
                    
                    <Skeleton v-if="!(transporters.length > 0)" />
                </div>
                
                <label for="Freight_Master" class="col-2">{{$t('freight_master')}}</label>
                <div class="col-4 md-4">
                    <InputText name="Freight_Master" type="text" disabled v-model="transporters[0].freight_master" v-if="transporters.length > 0" />
                    <Skeleton v-if="!(transporters.length > 0)" />
                </div>
            </div>
            <div class="field grid" v-if="!isRelation">
                <label for="Assign_Reason" class="col-2">{{$t('reason')}}</label>
                <div class="col-4 md-4">
                    <CustomSelect class="p-inputtext-sm" v-model="transporters[0].assign_reason" :url="this.$API_URL + 'list/lookup'" :minLength="0" :params="{ group: this.$LOOKUP_GROUP.ASSIGN_TRANSPORTER_REASON }" v-if="transporters.length > 0" @change="onAssignReasonChange($event, 0)" :disabled="!(transporters[0].require_reason) || disableInput" />
                    <Skeleton v-if="!(transporters.length > 0)" />
                </div>
            </div>
            <div class="field grid" v-if="!isRelation">
                <label for="Assign_Reason_Others" class="col-2">&nbsp;</label>
                <div class="col-4 md-4">
                    <Textarea :autoResize="true" rows="5" v-if="transporters.length > 0" v-model="transporters[0].assign_reason_others" :disabled="!(transporters[0].require_reason_others) || disableInput" />
                    <Skeleton v-if="!(transporters.length > 0)" />
                </div>
            </div>
        </div>
        <div v-else-if="isCollective">
            <DataTable 
                :loading="!assignModel" 
                :value="transporters ? transporters : null" 
                class="p-datatable-sm editable-cells-table"
                :scrollable="true"
                scrollDirection="both"
                scrollHeight="400px"
                >
                <Column :exportable="false" bodyStyle="width:30px;display:table-cell" v-if="!validateAutoAssign">
                    <template #header="">
                        <Button label="" icon="pi pi-plus" class="p-button-primary p-mr-2 p-button-sm" @click="addDetail" :disabled="orderLinkSTO || disableInput"/>
                    </template>
                    <template #body="slotProps">
                        <Button icon="pi pi-minus" class="p-button-danger p-mr-2 p-button-sm" @click="deleteDetail(slotProps)" :disabled="orderLinkSTO  || disableInput" />
                    </template>
                </Column>
                <Column field="transporter_code" :header="$t('transporter')" key="transporter_code" headerStyle="width:20vw" bodyStyle="width:20vw;display:table-cell"> 
                    <template #body="slotProps">
                        <div class="field">
                            <div class="p-inputgroup" >
                                <InputText name="Transporter_Code" type="text" disabled v-model="slotProps.data.transporter_name"/>
                                <Button icon="pi pi-ellipsis-h" class="p-button p-button-sm" @click="onShowTransporterModal(slotProps.index)" />
                            </div>
                        </div>
                    </template>
                </Column>
                <Column field="truck_type_id" :header="$t('truck_type')" key="truck_type_id"  headerStyle="width:15vw" bodyStyle="width:15vw;display:table-cell">
                    <template #body="slotProps">
                        <div class="fluid">
                            <CustomSelect class="p-inputtext-sm" v-model="slotProps.data.truck_type_id" :url="this.$API_URL + 'list/truck_type'" :minLength="0" :params="{ }" disabled />
                        </div>
                        
                    </template>
                </Column>
                <Column field="freight_cost" :header="$t('freight_cost')"  headerStyle="width:10vw" bodyStyle="width:10vw;display:table-cell">
                    <template #body="slotProps" >
                        <InputNumber  name="Freight_Cost" mode="decimal" :optionalDecimal="true" v-model="slotProps.data.freight_cost" @blur="onFreightCostChange($event, slotProps.index)"  :disabled="orderLinkSTO || disableInput || validateAutoAssign"/>
                    </template>
                </Column>
                <Column field="freight_master" :header="$t('freight_master')"  headerStyle="width:10vw" bodyStyle="width:10vw;display:table-cell" >
                    <template #body="slotProps">
                        <InputText name="Freight_Master" type="text" disabled v-model="slotProps.data.freight_master" />
                    </template>
                </Column>
                <Column field="assign_reason" :header="$t('assign_reason')"  headerStyle="width:15vw" bodyStyle="width:15vw;display:table-cell">
                    <template #body="slotProps">
                        <CustomSelect  class="p-inputtext-sm" v-model="slotProps.data.assign_reason" :url="this.$API_URL + 'list/lookup'" :minLength="0" :params="{ group: this.$LOOKUP_GROUP.ASSIGN_TRANSPORTER_REASON }" v-if="assignModel" @change="onAssignReasonChange($event, slotProps.index)" :disabled="!(slotProps.data.require_reason) || disableInput" />
                    </template>
                </Column>
                <Column field="assign_reason_others" :header="''"  headerStyle="width:25vw" bodyStyle="width:25vw;display:table-cell">
                    <template #body="slotProps">
                        <div class="p-fluid">
                            <Textarea :autoResize="true" rows="1" v-model="slotProps.data.assign_reason_others" :disabled="!(slotProps.data.require_reason_others) || disableInput" />
                        </div>
                    </template>
                </Column>
                <Column field="transporter_notes" :header="$t('transporter_notes')"  headerStyle="width:25vw" bodyStyle="width:25vw;display:table-cell">
                    <template #body="slotProps">
                        <Textarea :autoResize="false" rows="1"  v-model="slotProps.data.transporter_notes" :disabled="disableInput" />
                    </template>
                </Column>
            </DataTable>
        </div>
    </div>

    <Dialog v-model:visible="showTransporterModal" header="Select Transporter" :draggable="false" :modal="true" :breakpoints="{'960px': '75vw', '640px': '100vw'}" style="width:75vw">
        <div class="grid">
            <div class="col-12">
                <div class="field grid">
                    <label for="Number_Of_Trip" class="col-2 p-p-2">{{$t('user_num_trip')}}</label>
                    <div class="col-4 md-4">
                        <InputNumber v-model="selectTransporterNumTrip" mode="decimal" minFractionDigits="0" maxFractionDigits="0" @blur-data="onChangeUserNumTrip" :disabled="shipmentType == $SHIPMENT_TYPE.INDIVIDUAL_TRUCK"/>
                        <Skeleton v-if="!assignModel" />
                    </div>
                </div>
            </div>
            <div class="col-12">
                <div class="field grid">
                    <label for="Truck_Rental" class="col-2 p-p-2">{{$t('truck_rental')}}</label>
                    <div class="col-4 md-4">
                        <Checkbox v-model="truckRental" :binary="true" @input="onChangeTruckRental" />
                        <Skeleton v-if="!assignModel" />
                    </div>
                </div>
            </div>
        </div>

        <DataTable 
            :loading="isLoading" 
            @row-dblclick="onTransporterDialogSelect" 
            :value="transportersList" 
            responsiveLayout="scroll" 
            class="p-datatable-sm editable-cells-table"
            v-model:expandedRows="expandedRows"
            @rowExpand="onRowExpand"
            :rowClass="selectedTransporter"
            v-model:selection="selectedRow" 
            selectionMode="single" 
            dataKey="key" 
            :metaKeySelection="false" 
            @update:selection="onSelect($event)"
            >
            <Column :exportable="false" :sortable="false" headerStyle="white-space:nowrap" :expander="true">
            </Column>
            <Column field="zfrcost_no" :header="$t('zfrcost_no')" style="width:10%">
            </Column>
            <Column field="transporter_name" :header="$t('transporter')" key="transporter_name" style="width:10%">  
            </Column>
            <Column field="truck_type_name" :header="$t('truck_type')" key="truck_type_id">
            </Column>
            <Column field="truck_capacity" :header="$t('capacity')">
                <template #expansion="slotProps">
                    {{$formatNumber(slotProps.data.truck_capacity)}}
                </template>
            </Column>
            <Column field="total_based" :header="$t('freight_kg_based')" key="total_based" style="width:10%">
            </Column>
            <Column field="per" header="Freight Cost Per" key="per" style="width:15%">
            </Column>
            <Column field="master_cost" header="Freight (Master Data)" key="master_cost" style="width:15%">
            </Column>
             <Column field="uom" header="UOM" key="uom" style="width:15%">
            </Column>
            <!--  <Column field="cost" header="Biaya Pengiriman (Per UoM)" key="cost" style="width:10%">
            </Column> -->
            <Column field="total_cost" :header="$t('freight_total_cost')" key="total_cost" style="width:10%">
            </Column>
            <Column field="total_kg" :header="$t('freight_kg')" key="total_kg" style="width:10%" bodyStyle="color:red">
            </Column>
            <Column field="system_not" :header="$t('system_num_trip')" key="total_cost" style="width:10%">
            </Column>
            <Column field="user_not" :header="$t('user_num_trip')" key="total_cost" style="width:10%">
            </Column>
            <Column field="route_no" :header="$t('route_no')" key="route_no" style="width:10%">
            </Column>
            <Column field="tender_no" :header="$t('tender_no')" key="tender_no" style="width:10%">
            </Column>    
            <Column field="total_cost_user_not" :header="$t('freight_total_cost_user_not')" key="total_cost" style="width:10%">
            </Column>
            <template #expansion="slotProps">
                <div class="orders-subtable">
                    <DataTable :value="slotProps.data.materials">
                        <Column field="Material_Name" :header="$t('material_name')" class="w-6"></Column>
                        <Column field="Qty" :header="$t('qty')"></Column>
                        <Column field="UOM" :header="$t('uom')"></Column>
                        <Column field="Freight_Master" :header="$t('freight_master')"></Column>
                        <Column field="Freight_Total_Cost" :header="$t('freight_total_cost')"></Column>
                    </DataTable>
                </div>
            </template>
        </DataTable>
    </Dialog>

</template>
<script>
    export default{
        emits: ["block", "unblock", "reset-approval"],
        props:{
            transporters: {
                type: Array,
                default: null
            },
            isIndividual:{
                type: Boolean,
                default: false,
            },
            isCollective: {
                type:Boolean,
                default: false,
            },
            isRelation:{
                type:Boolean,
                default: false,
            },
            assignModel:{
                type:Object,
                default: null
            },
            truckRental:{
                type:Boolean,
                default:false
            },
            // selectTransporterNumTrip:{
            //     type: Number,
            //     default: 1
            // },
            data: {
                type: Object,
                default: null
            },
            materials:{
                type:Array,
                default: []
            },
            sapOrders:{
                type:Array,
                default: []
            },
            stuffingDateFrom: {
                type:String,
                default: ""
            },
            stuffingDateTo: {
                type: String,
                default: ""
            },
            orderLinkSTO:{
                type:Boolean,
                default:false
            },
            excludeTransporters: {
                type: String,
                default:""
            },
            blockLoading:{
                type:Boolean,
                default: false
            },
            blockDestination:{
                type:Boolean,
                default:false
            },
            mode:{
                type:String,
                default: ""
            },
            shipmentType:{
                type:String,
                default: ""
            },
            phase2:{
                type:Boolean,
                default:false
            },
            requireLNIncoRule:{
                type: Boolean,
                default:false
            },
            disableLNType:{
                type: Boolean,
                default:true
            },
            disableRouteTenderNo:{
                type:Boolean,
                default:false
            },
            hideTenderNo:{
                type:Boolean,
                default:false
            },
            showSTOSPOPerShipment:{
                type:Boolean,
                default:false
            },
            allowMultipleWeighing:{
                type:Boolean,
                default:false
            }
        },
        data(){
            return{
                dataUrl:this.$API_URL+"saporder",
                blocked: false,
                transportersList: [],
                showTransporterModal: false,
                isLoading: true,
                expandedRows: [],
                selectedIndex: 0,
                selectedRow: null,

                selectTransporterNumTrip: 1,
            }
        },
        watch:{
            assignModel(newValue){
                if(newValue!=null && this.validateAutoAssign){
                    this.getSoTransporterList()
                }
            }
        },
        watch:{
            assignModel(newValue){
                if(newValue!=null && this.validateAutoAssign){
                    this.getSoTransporterList()
                }
            }
        },
        watch: {
            sapOrders: {
                handler(newVal) {
                    if (newVal && newVal.length > 0) {
                        this.assignModel.truck_type = newVal[0].Truck_Type || "N/A";
                    }
                },
                deep: true,
                immediate: true
            }
        },
        methods:{
            resetTransporter(){
                if(!this.isRelation)
                {
                    if(this.isCollective){
                        this.transporters = [];
                    }
                    else{
                        var model = this.transporters[0];
                        model.transporter_code = null;
                        model.transporter_name = null;
                        model.require_reason = null;
                        model.require_reason_others = null;
                        model.freight_cost = null;
                        model.freight_total_cost = null;
                        model.freight_total_cost_user_not = null;
                        model.freight_per = null;
                        model.freight_suggested = null;
                        model.freight_master = null;
                        model.freight_uom = null;
                        model.freight_container = null;
                        model.user_not = null;
                        model.system_not = null;
                        model.truck_type_id = null;
                        model.zfrcost_no = null;

                        model.trip_type = null;
                        model.use_route = null;
                        model.route_no = null;

                        model.use_tender = null;
                        model.tender_no = null;

                    }
                }
                this.$emit("reset-approval");
            },
            onRowExpand(event){
                this.expandedRows = [];
                this.expandedRows.push(event.data);
            },
            onAssignReasonChange(event, index){
                if(event){
                    var requireOthers = event.Lookup_Info1 == "Y";
                    this.transporters[index].require_reason_others = requireOthers;
                }               
            },
            changeTransporterData(index, data){
                var model = this.transporters[index];

                model.transporter_name = data.transporter_name;
                model.transporter_code = data.transporter_code;
                model.freight_cost = data.cost;
                model.freight_suggested = data.cost;
                model.freight_value = data.is_value;
                model.freight_per = data.per;
                model.truck_type_id = data.truck_type_id;
                model.freight_uom = data.is_value ? data.numtrip : data.uom;
                model.freight_total_cost_user_not = data.total_cost_user_not;
                model.freight_total_cost = data.total_cost_user_not;
                model.freight_master = data.master_cost;
                model.truck_capacity = data.freight_capacity;
                model.freight_kg = data.total_kg_user;
                model.freight_material = data.materials;
                var container = this.selectTransporterNumTrip;
                model.freight_container = container;
                model.system_not = data.system_not;
                model.truck_rental = this.truckRental;
                model.exclude_approval = data.exclude_approval;
                model.zfrcost_no = data.zfrcost_no;

                this.assignModel.route_no = data.route_no;
                this.assignModel.route_name = data.route_name;
                this.assignModel.tender_no = data.tender_no;
            },
            onQtyChange(){
                if(this.transporters != null && this.transporters.length > 0){
                    for(var i = 0; i< this.transporters.length;i++){
                        var model = this.transporters[i];
                        this.refreshFreightCost(model, i);
                    }
                }
            },
            onFreightCostChange(event, index){
                var model = this.transporters[index];
                var number = event.valueNumber;

                if(number == model.freight_cost)
                    return;

                model.freight_cost = event.value;
                if(!model.freight_criteria){
                    model.require_reason = parseFloat(model.freight_cost) > parseFloat(model.freight_suggested);
                }
                else{
                    model.require_reason = true;
                }      

                this.$emit("reset-approval");

                this.$nextTick(() => {
                    this.refreshFreightCost(model, index);
                });

                
                
            },
            refreshFreightCost(nmodel, index){
                var self = this;
                
                if(nmodel.transporter_code){
                    this.$emit("block");
                    this.$axios.post(this.$API_URL + "util/refresh_freight_cost", this.transporterModel(true, index))
                        .then((response) => {
                            if(response){
                                var data = response.data.data[0];

                                var model = this.transporters[index];
                                model.transporter_name = data.transporter_name;
                                model.transporter_code = data.transporter_code;
                                model.freight_cost = data.cost;
                                //model.freight_suggested = data.cost;
                                model.freight_value = data.is_value;
                                model.freight_per = data.per;
                                model.truck_type_id = data.truck_type_id;
                                model.freight_uom = data.is_value ? data.numtrip : data.uom;
                                model.freight_total_cost_user_not = data.total_cost_user_not;
                                model.freight_total_cost = data.total_cost;
                                model.freight_master = data.master_cost;
                                model.truck_capacity = data.freight_capacity;
                                model.freight_kg = data.total_kg_user;
                                model.system_not = data.system_not;
                                model.freight_material = data.materials;
                                var container = this.selectTransporterNumTrip;
                                model.freight_container = container;
                                model.zfrcost_no = data.zfrcost_no;
                            }
                            self.$emit("unblock");
                        })
                        .catch(function (err) {
                            self.$showToast({ severity: 'error', summary: "Error", detail: err.message, life: 120000});
                            self.$emit("unblock");
                        });
                }
            },
            onShowTransporterModal(index){
                this.selectedRow = null;
                var loading = this.assignModel.loading_destination_from_id;
                var destination = this.assignModel.loading_destination_to_id;
                var chargeOACompany = this.assignModel.charge_oa_company;
                var warehouseCode = this.assignModel.warehouse_code;
                var documentType = this.assignModel.document_type;
                var freightDate = this.assignModel.freight_date;

                this.selectedIndex = index;

                if(loading == 0){
                    this.showError("Error", this.$t('alert.require_loading')); //({ severity: 'error', summary: "Error", detail: this.$t('alert.require_loading'), life: 120000});
                    return;
                }

                if(destination == 0){
                    this.showError("Error", this.$t('alert.require_destination')); 
                    return;
                }

                if(!chargeOACompany){
                    this.showError("Error", this.$t('alert.require_charge_oa_company'));
                    return;
                }

                if(!freightDate){
                    this.showError("Error", this.$t('alert.require_freight_date'));
                    return;
                }

                var continueRun = true;
                if(this.materials && this.materials.length > 0){
                    var materials = [];
                    for(var x = 0; x< this.materials.length;x++){
                        var mat = this.materials[x];
                        console.log(mat);
                        if(mat.include_merge)
                        {
                            if(mat.Conversion_Type == "" || !mat.Conversion_Type){
                                this.showError("Error", this.$t('alert.require_conversion_type'));
                                continueRun = false;
                                break;
                            }
                        }
                            
                    }
                }

                if(!continueRun)
                    return;
                


                this.showTransporterModal = true;

                this.getTransporterList();

            },
            getTransporterList(){
                var self = this;

                self.blocked = true;
                self.transportersList = [];

                this.isLoading = true;

                this.$axios.post(this.$API_URL + "list/transporter_freight", this.transporterModel(false))
                    .then((response) => {
                        if(response){
                            self.transportersList = response.data;
                        }
                        self.blocked = false;
                        self.isLoading = false;
                    })
                    .catch(function (err) {
                        self.$showToast({ severity: 'error', summary: "Error", detail: err.message, life: 120000});
                        self.blocked = false;
                        self.isLoading = false;
                        self.showTransporterModal = false;
                    });
            },
            getSoTransporterList(){
                var self = this;
                self.blocked = true;
                self.isLoading = true;
                self.transportersList = [];
                let refNo = "";
                if(this.data.Order_Type == this.$ORDER_TYPE.IPB){
                    if(!this.data.LN_SO_No){
                        this.showError("Error","LN SO No. not found");
                        return;
                    }
                    refNo = this.data.LN_SO_No;
                }
                if(this.data.Order_Type == this.$ORDER_TYPE_NAME.TO_IN && this.data.Langsir_Type == this.$SAP_ORDER_LANGSIR.DALAM_PABRIK){
                    if(!this.data.Reference_Doc_No){
                        this.showError("Error","Reference TO Out Doc No. not found");
                        return;
                    }
                    if(!this.data.has_reference_order){
                        this.showError("Error","Referenced TO OUT has not assigned transporter yet");
                        return;
                    }
                    refNo = this.data.Reference_Doc_No;
                }
                this.$axios.get(`${this.dataUrl}/do_transporters/${refNo}`)
                    .then((response)=>{
                        if(response && response.data.success){
                            var header = response.data.data.header;
                            self.assignModel.loading_destination_from_id = header.loading_destination_from_id;
                            self.assignModel.loading_destination_to_id = header.loading_destination_to_id;
                            self.assignModel.stuffing_date = header.stuffing_date
                            self.assignModel.vessel = header.vessel;
                            self.assignModel.charge_oa_company = header.charge_oa_company;
                            self.assignModel.freight_date = header.freight_date;
                            response.data.data.detail.forEach((el,i)=>{
                                this.transporters.push(el)
                            })
                        }else{
                            this.showError("Error",response.data.message);
                        }
                        self.blocked = false;
                        self.isLoading=false;
                    })
                    .catch((err)=>{
                        this.showError("Error",err.message);
                        self.blocked = false;
                        self.isLoading = false;
                    })
            },
            showError(summary, message) {
                this.$toast.add({ severity: 'error', summary: summary, detail: message, life: 120000});
            },
            onChangeUserNumTrip(){
                this.$nextTick(() => {
                    this.getTransporterList();
                });
                
            },
            onChangeTruckRental(){
                this.$nextTick(() => {
                    this.getTransporterList();
                });
                
            },
            onTransporterDialogSelect(event){
                var data = event.data;
                var model = this.transporters[this.selectedIndex];
                var self = this;

                this.changeTransporterData(this.selectedIndex, data);

                self.$emit("reset-approval");

                var reasonCriteria = "";
                var useReason = false;

                if(!data.exclude_approval){
                    if(data.total_kg != data.recommended_kg){
                        reasonCriteria = this.$ASSIGN_MATRIX_TYPE.HIGHER;
                        useReason = true;

                        if(this.relationTransporter == data.transporter_code){
                            useReason = false;
                        }
                    }
                    else{
                        if(data.system_not < data.user_not){
                            reasonCriteria = this.$ASSIGN_MATRIX_TYPE.DIFFERENT_NOT;
                            useReason = true;
                        }
                    }
                }
                else{
                    reasonCriteria = this.$ASSIGN_MATRIX_TYPE.LOWER;
                }

                var x = {
                    transporter_code: data.transporter_code,
                    order_ids: this.sapOrderIds.toString()
                }; 

                self.isLoading = true;

                this.$axios.get(this.$UTIL_URL + "transporter_exceed_quota/", { params: x })
                    .then((response) => {
                        if(response){
                            if(response.data.success){
                                var data = response.data.data;

                                if(data.exceed){
                                    useReason = true;
                                }

                                if(!reasonCriteria)
                                    reasonCriteria = this.$ASSIGN_MATRIX_TYPE.EXCEED;

                                if(useReason){
                                    model.exceed_message = response.data.data.message;
                                }
                            }
                            else{
                                self.showError('Error Getting Transporter Quota', response.data.message);
                            }
                        }

                        model.freight_criteria = reasonCriteria;
                        model.require_reason = useReason;

                        self.isLoading = false;
                         self.showTransporterModal = false;
                    })
                    .catch(function (error) {
                        self.showError('Error Getting Transporter Quota', error);

                         self.isLoading = false;
                          self.showTransporterModal = false;
                    });
            },
          
            transporterModel(includeTransporters, index){
                var loading = this.assignModel.loading_destination_from_id;
                var destination = this.assignModel.loading_destination_to_id;
                var chargeOACompany = this.assignModel.charge_oa_company;
                var warehouseCode = this.assignModel.warehouse_code;
                var documentType = this.assignModel.document_type;
                var freightDate = this.assignModel.freight_date;

                var tripType = this.assignModel.trip_type;
                var useRoute = this.assignModel.use_route;
                var useTender = this.assignModel.use_tender;
                var multipleWeighing = this.assignModel.multiple_weighing;

                var selected = [];
                if(includeTransporters){
                    if(index == null){
                        selected = this.transporters;
                    }
                    else{
                        selected.push(this.transporters[index]);
                    }
                }

                var materials = [];
                if(this.materials && this.materials.length > 0){
                    for(var x = 0; x< this.materials.length;x++){
                        var mat = this.materials[x];
                        console.log(mat);
                        if(mat.include_merge){
                            materials.push(mat);
                        }
                    }
                }
                var truckTypes = [...new Set(this.sapOrders.map(order => order.Truck_Type))];
                var data = {
                    loading: loading,
                    destination: destination,
                    exclude_transporters: this.excludeTransporterIds,
                    materials: materials,
                    container: this.selectTransporterNumTrip,
                    charge_oa_company: chargeOACompany,
                    warehouse_code: warehouseCode,
                    document_type: documentType,
                    freight_date: freightDate,
                    sap_order_ids: this.sapOrderIds,
                    shipment_type: this.shipmentType,
                    truck_rental: this.truckRental,
                    trip_type: tripType,
                    use_route: useRoute,
                    use_tender: useTender,
                    truck_types: truckTypes,
                    multiple_weighing: multipleWeighing,
                    selected_transporters: selected//includeTransporters ? this.transporters : []
                };

                return data;
            },
            addDetail(){
                var det = { ...this.assignModel.transporters };

                this.transporters.push(det);
            },
            deleteDetail(event){
                if (event) {
                    var detail = this.transporters[event.index];
                    this.transporters.splice(this.transporters.indexOf(detail), 1);
                }
            },
            selectedTransporter(data){
                var transporter = this.transporters[this.selectedIndex];

                if(transporter.freight_value == data.is_value && transporter.transporter_code == data.transporter_code && data.truck_type_id == transporter.truck_type_id){
                    return 'selected-transporter';
                }
                else return '';
            },
            onSelect(event){
                this.selectedRow = event;
            },

        },
        computed:{
            validateAutoAssign(){
                if(this.data.Order_Type=="IPB IN" || this.data.Order_Type == "IPB OUT"){
                    if(this.data.Document_Type == "EXPORT" && this.isCollective){
                        return true;
                    }
                }
                else if(this.data.Order_Type==this.$ORDER_TYPE_NAME.TO_IN && this.data.Langsir_Type == this.$SAP_ORDER_LANGSIR.DALAM_PABRIK){
                    return true;
                }
                return false;
            },
            sapOrderIds(){
                var a = this.sapOrders.map(function(v){
                    return v.Id;
                });
                return a;
            },
            excludeTransporterIds(){
                var excludes = [];

                if(this.excludeTransporters){
                    var b = this.excludeTransporters.split(",");
                    excludes = excludes.concat(b);
                }

                if(this.transporters && this.transporters.length > 1){
                    var a = this.transporters.map(function(v){
                        return v.transporter_code;
                    });
                    excludes = excludes.concat(a);
                }
                
                return excludes;
            },
            stuffingDateFromRange(){
                return this.stuffingDateFrom ? new Date(this.stuffingDateFrom) : null;
            },
            stuffingDateToRange(){
                return this.stuffingDateTo ? new Date(this.stuffingDateTo) : null;
            },
            disableInput(){
                return this.mode == this.$FORM_MODE_EDIT;
            },
            sapTruckTypesDisplay() {
                if (this.sapOrders && this.sapOrders.length > 0) {
                    return [...new Set(this.sapOrders.map(order => order.Truck_Type).filter(Boolean))].join(", ");
                }
                return "";
            }
        }
    }

</script>